export interface ArchiveCardStats {
  peakParticipants: number | null;
  viewCount: number | null;
  messageCount: number | null;
}

// Month names in genitive form for Russian
const MONTHS_RU_GENITIVE = [
  'января',
  'февраля',
  'марта',
  'апреля',
  'мая',
  'июня',
  'июля',
  'августа',
  'сентября',
  'октября',
  'ноября',
  'декабря',
];

export const formatRecordingDurationMmSs = (totalSec: number): string => {
  const m = Math.floor(totalSec / 60);
  const s = totalSec % 60;
  return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
};

export const formatAbsoluteDateRu = (iso: string): string => {
  const d = new Date(iso);
  const day = d.getDate();
  const month = MONTHS_RU_GENITIVE[d.getMonth()];
  const hh = String(d.getHours()).padStart(2, '0');
  const mm = String(d.getMinutes()).padStart(2, '0');
  return `${day} ${month} · ${hh}:${mm}`;
};

export const buildArchiveStatRow = (stats: ArchiveCardStats): string[] => {
  const segments: string[] = [];
  if (stats.peakParticipants != null) segments.push(`${stats.peakParticipants} было`);
  if (stats.viewCount != null) segments.push(`${stats.viewCount} просм`);
  if (stats.messageCount != null) segments.push(`${stats.messageCount} сообщений`);
  return segments;
};
